import { isDemoMode } from "../../utils/demoUser";

export const DemoModeButton = () => {
  const isDemo = isDemoMode();

  // Only show in development when demo mode is active
  if (!isDemo) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-[9999] bg-yellow-100 border-2 border-yellow-400 text-yellow-800 px-3 py-2 rounded-lg shadow-lg text-sm font-semibold">
      🎭 デモモード
    </div>
  );
};
